import React, { useState, useCallback, useMemo } from 'react';
import { publish } from '@wh/message-bus';
import './ActionArea.scss';

import { SearchIcon } from './SearchIcon';
import { CloseIcon } from './CloseIcon';
import { MailIconWithCount } from './MailIconWithCount';
import { LoginButton } from './buttons/Login';
import { RegistrationButton } from './buttons/Registration';
import { DepositButton } from './buttons/Deposit';
import { depositLinkClicked, useMessageBusSubscribe } from '../messagebus';
import DepositLinkIcon from './DepositLinkIcon';
import { isGamingWrapper } from '../../../utils';

const BLOOMREACH_INBOX_STATE_CHANGED = 'wh.hybrid.event.inbox.state.changed';
const INBOX_CLICKED = 'wh.kraken.event.ui.header.inbox.clicked';

export const ActionArea = ({ content, buildVertical, buttonVisibility }) => {

  const {
    depositLinkButtonVisible,
    loginButtonVisible,
    registrationButtonVisible,
    depositButtonVisible
  } = buttonVisibility;

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [inboxUnreadCount, setInboxUnreadCount] = useState(null);

  useMessageBusSubscribe('search.open', () => { setIsSearchOpen(true); });
  useMessageBusSubscribe('search.close', () => { setIsSearchOpen(false); });
  useMessageBusSubscribe(BLOOMREACH_INBOX_STATE_CHANGED, ({ unreadCount }) => {
    setInboxUnreadCount(unreadCount);
  });

  const searchClicked = useCallback(() => {
    if (buildVertical?.startsWith('sportsbook')) {
      if (isSearchOpen) {
        publish('search.close');
      } else {
        publish('search.open');
      }
    } else {
      publish('wh.common.event.ui.header.search.clicked');
    }
  }, [buildVertical, isSearchOpen]);

  const inboxClicked = useCallback(() => {
    publish(INBOX_CLICKED);
  }, []);

  const showSearch = useMemo(
    () => buildVertical === 'gaming' || buildVertical === 'casino' || buildVertical?.startsWith('sportsbook'),
    [buildVertical]
  );

  const showInboxIcon = useMemo(() => {
    return isGamingWrapper() && !loginButtonVisible;
  }, [buildVertical, loginButtonVisible]);

  return <div className="sb-header__section sb-header__section--align-right" data-test-id="header.slot-actions">
      {loginButtonVisible && <LoginButton label={content?.['login-button']}/>}
      {registrationButtonVisible && <RegistrationButton label={content?.['registration-button']} />}
      {showInboxIcon && inboxUnreadCount != null && <div className="sb-header__item">
        <button className={`sb-header-inbox${inboxUnreadCount == 0 ? ' sb-header-inbox--read' : ''}`} onClick={inboxClicked}>
          <MailIconWithCount count={inboxUnreadCount} />
        </button>
      </div>}
      {depositLinkButtonVisible && <div className="sb-header__item">
        <button className='sb-header-deposit-link' onClick={depositLinkClicked}>
          <DepositLinkIcon />
        </button>
      </div>}
      {depositButtonVisible && <DepositButton label={content?.['deposit-button']} />}
      <div className="sb-header__item">
        <div id='cp-ma-wrapper'></div>
      </div>
      {showSearch && !showInboxIcon && <div className="sb-header__item">
        <button className='sb-header-search' onClick={searchClicked}>
          {isSearchOpen ? <CloseIcon /> : <SearchIcon />}
        </button>
      </div>}
    </div>;
}
